import SimplePage from "@/components/simple-page/index";
import CardNavigation from "@/components/card-navigation/index";
import PAGE from "./page.yaml";
import CARDS from "./cards.yaml";

export default {
  components: { CardNavigation, SimplePage },
  data() {
    return {
      sections: PAGE.sections,
      title: PAGE.title,
      cards: CARDS,
    };
  },
};
